import { dateService, FORMATS } from '@/global/services/date'
export default {
  name: 'Details',

  computed: {
    detailsCreateConfig () {
      return {
        title: this.$t('fleet/activity.vehicle_details'),
        key: 'details',
        validationErrors: this.validationErrors,
        tabContent: [
          {
            title: this.$t('fleet/activity.vehicle_details'),
            component: this.columnsContentComponent,
            rows: [
              {
                columnsCount: 4,
                fields: [
                  {
                    key: 'number_of_seats',
                    label: this.$t('fleet/vehicle_attribute.number_of_seats'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('number_of_seats'),
                    visible: this.detailsFields?.includes('number_of_seats'),
                    editable: this.detailsFields?.includes('number_of_seats')
                  },
                  {
                    key: 'engine_ccm',
                    label: this.$t('fleet/vehicle_attribute.engine_ccm'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('engine_ccm'),
                    visible: this.detailsFields?.includes('engine_ccm'),
                    editable: this.detailsFields?.includes('engine_ccm')
                  },
                  {
                    key: 'engine_power',
                    label: this.$t('fleet/vehicle_attribute.engine_power'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('engine_power'),
                    visible: this.detailsFields?.includes('engine_power'),
                    editable: this.detailsFields?.includes('engine_power')
                  },
                  {
                    key: 'co2_emission',
                    label: this.$t('fleet/vehicle_attribute.co2_emission'),
                    creatable: this.detailsFields?.includes('co2_emission'),
                    visible: this.detailsFields?.includes('co2_emission'),
                    editable: this.detailsFields?.includes('co2_emission')
                  },
                  {
                    key: 'euro_standard',
                    label: this.$t('fleet/vehicle_attribute.euro_standard'),
                    type: 'text',
                    creatable: this.detailsFields?.includes('euro_standard'),
                    visible: this.detailsFields?.includes('euro_standard'),
                    editable: this.detailsFields?.includes('euro_standard')
                  },
                  {
                    key: 'battery_voltage',
                    label: this.$t('fleet/vehicle_attribute.battery_voltage'),
                    type: 'text',
                    creatable: this.detailsFields?.includes('battery_voltage'),
                    visible: this.detailsFields?.includes('battery_voltage'),
                    editable: this.detailsFields?.includes('battery_voltage')
                  },
                  {
                    key: 'oil_type',
                    label: this.$t('fleet/vehicle_attribute.oil_type'),
                    creatable: this.detailsFields?.includes('oil_type'),
                    visible: this.detailsFields?.includes('oil_type'),
                    editable: this.detailsFields?.includes('oil_type')
                  },
                  {
                    key: 'antifreeze_type',
                    label: this.$t('fleet/vehicle_attribute.antifreeze_type'),
                    creatable: this.detailsFields?.includes('antifreeze_type'),
                    visible: this.detailsFields?.includes('antifreeze_type'),
                    editable: this.detailsFields?.includes('antifreeze_type')
                  },
                  {
                    key: 'tire_size',
                    label: this.$t('fleet/vehicle_attribute.tire_size'),
                    creatable: this.detailsFields?.includes('tire_size'),
                    visible: this.detailsFields?.includes('tire_size'),
                    editable: this.detailsFields?.includes('tire_size')
                  },
                  {
                    key: 'manufacture_year',
                    label: this.$t('fleet/vehicle_attribute.manufacture_year'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('manufacture_year'),
                    visible: this.detailsFields?.includes('manufacture_year'),
                    editable: this.detailsFields?.includes('manufacture_year')
                  },
                  {
                    key: 'vin',
                    label: this.$t('fleet/vehicle_attribute.vin'),
                    creatable: this.detailsFields?.includes('vin'),
                    visible: this.detailsFields?.includes('vin'),
                    editable: this.detailsFields?.includes('vin')
                  },
                  {
                    key: 'empty_weight',
                    label: this.$t('fleet/vehicle_attribute.empty_weight'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('empty_weight'),
                    visible: this.detailsFields?.includes('empty_weight'),
                    editable: this.detailsFields?.includes('empty_weight')
                  },
                  {
                    key: 'maximum_weight',
                    label: this.$t('fleet/vehicle_attribute.maximum_weight'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('maximum_weight'),
                    visible: this.detailsFields?.includes('maximum_weight'),
                    editable: this.detailsFields?.includes('maximum_weight')
                  },
                  {
                    key: 'load_capacity',
                    label: this.$t('fleet/vehicle_attribute.load_capacity'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('load_capacity'),
                    visible: this.detailsFields?.includes('load_capacity'),
                    editable: this.detailsFields?.includes('load_capacity')
                  },
                  {
                    key: 'top_speed',
                    label: this.$t('fleet/vehicle_attribute.top_speed'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('top_speed'),
                    visible: this.detailsFields?.includes('top_speed'),
                    editable: this.detailsFields?.includes('top_speed')
                  },
                  {
                    key: 'length',
                    label: this.$t('fleet/vehicle_attribute.length'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('length'),
                    visible: this.detailsFields?.includes('length'),
                    editable: this.detailsFields?.includes('length')
                  },
                  {
                    key: 'width',
                    label: this.$t('fleet/vehicle_attribute.width'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('width'),
                    visible: this.detailsFields?.includes('width'),
                    editable: this.detailsFields?.includes('width')
                  },
                  {
                    key: 'extinguisher_expiry',
                    label: this.$t('fleet/vehicle_attribute.extinguisher_expiry'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          extinguisher_expiry: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    creatable: this.detailsFields?.includes('extinguisher_expiry'),
                    visible: this.detailsFields?.includes('extinguisher_expiry'),
                    editable: this.detailsFields?.includes('extinguisher_expiry')
                  },
                  {
                    key: 'enc',
                    label: this.$t('fleet/vehicle_attribute.enc'),
                    creatable: this.detailsFields?.includes('enc'),
                    visible: this.detailsFields?.includes('enc'),
                    editable: this.detailsFields?.includes('enc')
                  },
                  {
                    key: 'driver_auto_logout_timeout',
                    label: this.$t('fleet/vehicle_attribute.driver_auto_logout_timeout'),
                    field_type: 'number',
                    creatable: this.detailsFields?.includes('driver_auto_logout_timeout'),
                    visible: this.detailsFields?.includes('driver_auto_logout_timeout'),
                    editable: this.detailsFields?.includes('driver_auto_logout_timeout')
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
